var render = function render(){var _vm=this,_c=_vm._self._c;return _c('m-col',{staticClass:"home-table-empty",attrs:{"ai":"center","jc":"center"}},[_c('p',{staticClass:"home-table-empty__title"},[_vm._v("Add your first Video to start!")]),_c('m-button',{scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c('m-icon',{attrs:{"icon":"plus"}})]},proxy:true}])},[_vm._v("Add New Video ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }